import React from 'react'
import {
  TextField,
  Autocomplete,
} from "@mui/material";

function SearchBarDashboard({id, value, data, handleChange, disabled, label, width, disableClearable}) {
  return (
    <Autocomplete
      disablePortal
      id={id}
      size="small"
      color="secondary"
      sx={{
        width: {width},
        height: 40,
        marginRight: 1,
        marginTop: 1,
      }}
      value={value}
      options={data}
      onChange={handleChange}
      disabled={disabled}
      renderInput={(params) => (
        <TextField {...params} label={label} />
      )}
      disableClearable={disableClearable}
    />
  )
}

export default SearchBarDashboard
